// Export the Registration API.
export default {
	apiService: {
		postRegister: {
			PATH_SEARCH: '/api/fusionAuth/registration/',
			PATH_METHOD: 'post',
		},
	},
};
